import { Preventif } from '@/models/Preventif';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { PreventifModuleState } from '.';
import { Periodicite, Vision } from '@/modules/Preventif/services/PreventifService';

export const getters: GetterTree<PreventifModuleState, RootState> = {
    getPreventif(state): Preventif[] {
        return state.preventif;
    },
    getDisplayPreventif(state): Preventif[] {
        if(state.siteFilter.length > 0){
            return state.displayPreventif.filter(p => p.libelle.toLowerCase().includes(state.siteFilter.toLowerCase()));
        } else {
            return state.displayPreventif;
        }
    },
    getSiteFilter(state): string {
        return state.siteFilter;
    },
    getHeaderPreventif(state): { dateDebut: string; dateFin: string }[] {
        return state.header;
    },
    getDisplayHeaderPreventif(state): { dateDebut: string; dateFin: string }[] {
        return state.displayHeader;
    },
    isReel(state){
        return state.previsionnel === Vision.REELLE;
    },
    isPeriodiciteHebdomadaire(state): boolean {
        return state.periodicite === Periodicite.HEBDOMADAIRE;
    },
    getIsLoadingPreventif(state): boolean {
        return state.isLoading;
    },
    getPagePreventif(state): number {
        return state.page;
    },
    getNbPeriodesAffichees(state): number {
        return state.nbPeriodesAffichees;
    },
    getNbPeriodesStep(state): number {
        return state.nbPeriodesStep;
    },
    getXlsInterventionsPreventivesLoading(state): boolean {
        return state.xlsInterventionsPreventivesLoading;
    },
    isAllData(state): boolean {
        return state.isAllData;
    },
    getLastSiteId(state): number | undefined {
        return state.lastSiteId;
    },
    isUniqueSite(state): boolean {
        return state.isUniqueSite;
    }
};
